import de from '../translations/de.json';
export default de;



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/de.js